export const REFERRAL_LINK = '?utm_source=Confluence&utm_medium=referral';

export const getUnsplashPhotos = async (
	queryWord: string,
	pageNumber: number,
	submitError: ((error: Error) => void) | undefined,
	shouldUseFullSizeImage?: boolean,
) => {
	try {
		const response = await fetch(
			`/wiki/rest/internals/1.0/unsplash/search?query=${queryWord}&pageNumber=${pageNumber}`,
			{
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
				},
			},
		);

		if (!response.ok) {
			throw new Error(`Received status ${response.status}`);
		}

		const responseData = await response.json();
		return responseData.results?.map((result: any) => ({
			id: result.id,
			altDescription: result.alt_description,
			smallSizeImageUrl: result.urls.thumb,
			fullSizeImageUrl: shouldUseFullSizeImage ? result.urls.full : result.urls.regular,
			artistName: result.user.name,
			artistUrl: result.user.links.html + REFERRAL_LINK,
			downloadLink: result.links.download_location,
		}));
	} catch (error) {
		const err = error instanceof Error ? error : new Error('An unknown error occurred');

		submitError?.(err);

		throw err;
	}
};
